export default "__VITE_ASSET__CyZxeq6c__"